import { axios } from "../utils/axios";
import { isAxiosError } from "axios";
import { toast } from "react-toastify";
import { useGeneralAppStore } from "../store/generalAppStore";
import { toastOptions } from "../config/toast";
import { useActasStore } from "../store/actasStore";
import { useNotificadoresStore } from "../store/notificadoresStore";
import { useRecibosPagosStore } from "../store/recibosPagosStore";

const useRecibosPagos = () => {
  const { setRecibos, setMontoTotal } = useRecibosPagosStore();
  const { handlerLoading, handlerModal } = useGeneralAppStore();

  //TREA TODO LOS NOTIFICADORES
  const getRecibosPagos = async (dataSend) => {
    handlerLoading({ loading: true, loadName: "recibos" });
    const response = await axios().post("/get_recibos", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        setMontoTotal(data.montoTotal);
        setRecibos(data.recibosPagos);
        // setNotificadores(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "recibos" });
  };

  //ASIGNA UN NOTIFICADOR A UN ACTA
  const asignarNotificador = async (dataSend) => {
    handlerLoading({ loading: true, loadName: "confirmarNotificador" });
    const response = await axios().post("/asignar_notificador", dataSend);
    if (!isAxiosError(response)) {
      const { data, error } = response.data;
      if (data && !error) {
        toast.success("Notificador asigando al acta", toastOptions);
        handlerModal({ modal: false, modalName: "notificadores" });
        // setNotificadores(data);
      }
      if (!data && error) {
        toast.error(error, toastOptions);
        // toast.error(error, toastOptions);
      }
    } else {
      toast.error("Hubo un error en la consulta", toastOptions);
    }
    handlerLoading({ loading: false, loadName: "confirmarNotificador" });
  };

  return { getRecibosPagos };
};

export default useRecibosPagos;
